import styled from '../theme/styled-components';

export const ArticleDate = styled.small`
  font-weight: ${props => props.theme.typography.meta.fontWeight};
  position: relative;
  top: -0.25rem;
`;

export const ArticleHeaderTitle = styled.h2`
  margin-bottom: 0;
  padding-top: 0;
  line-height: ${props => props.theme.typography.title.lineHeight};
`;

export const ArticlePreamble = styled.div`
  > p {
    margin-bottom: calc(${props => props.theme.spacings.tiny} / 2);
    font-size: ${props => props.theme.typography.body.fontSize};
  }
`;

export const NewsSummaryList = styled.div`
  width: 100%;
  ${media => media.theme.media.greaterThan('large')`
    padding-right: ${props => props.theme.spacings.large};
  `}
`;

export const FirstSection = styled.div`
  display: flex;
  flex-direction: column;

  ${media => media.theme.media.between('medium', 'downLarge')`
    flex-direction: row;
    &:not(:last-of-type) {
      padding-bottom: ${props => props.theme.spacings.large};
    }
  `}

  ${media => media.theme.media.greaterThan('large')`
    width: 17.5rem; // TODO: 
  `}
`;

export const ServiceSection = styled(FirstSection)`
  ${media => media.theme.media.between('medium', 'downLarge')`
    flex-direction: column;
  `}

  ${media => media.theme.media.greaterThan('large')`
    width: 100%; 
    flex-direction: column;
  `}
`;

export const SecondSection = styled(FirstSection)`
  flex-wrap: wrap;
  ${media => media.theme.media.greaterThan('large')`
    width: 100%;
    flex-direction: row;
    margin-left: 140px;  // TODO: 
  `}
`;

export const ArticleSection = styled.div`
  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
    flex-direction: column;
    padding-left: ${props => props.theme.spacings.large};
  `}

  ${media => media.theme.media.greaterThan('large')`
    padding-left: 0;
    flex-direction: column;
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
  `}
`;

export const ServiceArticleSection = styled(ArticleSection)`
  ${media => media.theme.media.greaterThan('medium')`
    padding-left: calc(${props => props.theme.spacings.large} + ${props =>
    props.theme.boxSizes.medium.width});
  `}
  ${media => media.theme.media.greaterThan('large')`
      justify-content: space-between;
      flex-direction: row;
      padding-left: 0;
      padding-top: ${props => props.theme.spacings.medium};
  `}
`;

export const ServiceArticleSectionImage = styled.div`
  width: 100%;

  ${media => media.theme.media.greaterThan('large')`
    max-width: calc(100% / 2);
    :not(:first-child) {
      padding-left: ${props => props.theme.spacings.large}
    }
  `}
`;

export const AboutUsArticleSection = styled(ServiceArticleSection)`
  ${media => media.theme.media.greaterThan('medium')`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  margin-left: 10.9375rem; // TODO!
  `}

  ${media => media.theme.media.greaterThan('large')`
    margin-top: 0;
    flex-direction: column;
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
    > div {
      width: calc(50% - ${props => props.theme.spacings.base});
    }
  `}
`;

export const ArticleHeader = styled.div`
  margin-bottom: ${props => props.theme.spacings.base};
  ${media => media.theme.media.greaterThan('medium')`
    margin-left: 0;
    margin-right: 0;
    padding-left: ${props => props.theme.spacings.large};
    h1 {
      padding-top: 0;
    }
  `}

  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
    align-items: self-start;
    flex-direction: column;
  `}
`;

export const ArticleIngress = styled.div`
  font-weight: ${props => props.theme.typography.subtitle.fontWeight};
  font-size: ${props => props.theme.typography.subtitle.fontSize};
  line-height: ${props => props.theme.typography.subtitle.lineHeight};
`;

export const ArticleSummery = styled(ArticleIngress)`
  font-size: ${props => props.theme.typography.body.fontSize};
`;

export const NewsSummery = styled(ArticleIngress)`
  padding-bottom: ${props => props.theme.spacings.base};

  ${media => media.theme.media.greaterThan('medium')`
    padding-bottom: ${props => props.theme.spacings.medium};
  `}
`;

export const ContentWrapper = styled.div`
  ${media => media.theme.media.greaterThan('large')`
    display: flex;
    flex-direction: row;
    align-items: self-start;
  `}
`;

export const ServiceWrapper = styled(ContentWrapper)`
  ${media => media.theme.media.greaterThan('large')`
    display: flex;
    flex-direction: column;
    align-items: self-start;
  `}
`;

export const ContactContentWrapper = styled.div`
  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
    flex-direction: column;
  `}
  ${media => media.theme.media.greaterThan('large')`
  flex-direction: row;
`}
`;

export const ContactSection = styled(FirstSection)`
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: ${props => props.theme.spacings.tiny};

  ${media => media.theme.media.between('medium', 'downLarge')`
    flex-direction: row;
    > div {
      width: calc(100% / 2 - ${props => props.theme.spacings.base});
    }
  `}

  ${media => media.theme.media.greaterThan('large')`
    width: 50%; 
    flex-direction: column;
  `}
`;

export const FormSection = styled.div`
  width: 100%;
  ${media => media.theme.media.greaterThan('medium')`
    order: -1;
    display: flex;
    justify-content: space-bwtween;
    
  `}
  ${media => media.theme.media.greaterThan('large')`
    margin-right: ${props => props.theme.spacings.large}
  `}
`;

export const SocialMediaBoxes = styled.div`
  display: none;
  justify-content: space-between;
  
  ${media => media.theme.media.lessThan('downLarge')`
    margin-top: ${props => props.theme.spacings.base};
  `}

  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
  `}

  ${media => media.theme.media.greaterThan('large')`
    flex-direction: column;
  `}
`;

export const SocialMediaBox = styled.div`
  height: 300px;
  width: 300px;
  background-color: ${props => props.theme.colors.border.dark.base};
  overflow: hidden;

  ${media => media.theme.media.greaterThan('large')`
    height: 340px;
    width: 340px;
    
    &:first-child {
      margin-bottom: ${props => props.theme.spacings.base};
    }
  `};
`;

export const NewsWrapper = styled(ServiceWrapper)`
  ${media => media.theme.media.greaterThan('medium')`
    flex-direction: row;
  `}
`;

export const ArticleTop = styled.div`
  display: flex;
  ${media => media.theme.media.lessThan('downMedium')`
    flex-direction: column;
  `}
`;

export const PageNotFoundSection = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;

  ${media => media.theme.media.lessThan('downMedium')`
    padding-top: ${props => props.theme.spacings.large};
  `};
`;
